import {
  MARKETPLACES, MARKETPLACES_EU, MARKETPLACES_FE, MARKETPLACES_NA, MarketplaceRegions,
} from 'src/constants/marketplaces';
import { Environments } from 'src/types/Environments';
import { getEnvironment } from 'src/utils';
import { Regions } from 'src/types/Regions';
import { Marketplaces } from 'src/types/Marketplaces';
import { REGION } from 'src/constants/region';

export const ValidMarketplaceIds: string[] = [...new Set(
  Object.values(MARKETPLACES).reduce((acc, value) => {
    const beta = value[Environments.beta];
    const gamma = value[Environments.gamma];
    const prod = value[Environments.prod];
    return [...acc, beta, gamma, prod];
  }, [] as string[]),
)];

export const validateMarketplaceId = (
  marketplaceId: string,
) => ValidMarketplaceIds.includes(marketplaceId);

export const getMarketplaceById = (environment: string, id: string) => {
  const marketplaces = Object.values(MARKETPLACES)
    .find((marketplace) => marketplace[getEnvironment(environment)] === id);
  return marketplaces!;
};

export const getDefaultMarketplace = (): Marketplaces => {
  switch (REGION.toLowerCase()) {
    case Regions.PDX:
      return Marketplaces.japan;
    case Regions.DUB:
      return Marketplaces.uk;
    default:
      return Marketplaces.usa;
  }
};

export const getMpNameFromId = (marketplaceId: string) => {
  const marketplacesWithMpName = Object
    .entries(MARKETPLACES)
    .map(([mpName, mpDetails]) => ({
      ...mpDetails,
      mpName: mpName as Marketplaces,
    }));
  const marketplaceDetailsSelected = marketplacesWithMpName.find((marketplace) => [
    marketplace.BETA,
    marketplace.GAMMA,
    marketplace.PROD,
  ].includes(marketplaceId));
  return marketplaceDetailsSelected?.mpName;
};

// eslint-disable-next-line consistent-return
export const getMpRegionFromId = (marketplaceId: string) => {
  const mpName = getMpNameFromId(marketplaceId);
  if (!mpName) return undefined;
  if (MARKETPLACES_NA.includes(mpName)) {
    return MarketplaceRegions.NA;
  }
  if (MARKETPLACES_EU.includes(mpName)) {
    return MarketplaceRegions.EU;
  }
  if (MARKETPLACES_FE.includes(mpName)) {
    return MarketplaceRegions.FE;
  }
};

export const isGroupsVisibleForMpId = (marketplaceId: string) => {
  const mpName = getMpNameFromId(marketplaceId);

  return mpName
    && MARKETPLACES_NA.includes(mpName);
};
